import isDev from "@mkt/utils/isDev"
import isDynamicValue from "@mkt/utils/isDynamicValue"
import getCurrentMonth from "@mkt/utils/getCurrentMonth"
import { STATIC_URL } from "gatsby-env-variables"

function getTitle(pageContext) {
  const { content } = pageContext
  const { hero, title } = content

  if (hero) {
    const isMonthDynamic = hero && isDynamicValue(hero[0]?.title, "[month]")
    const heroText = typeof hero[0].title === 'object'
      ? hero[0].title.content[0].content[0].text
      : hero[0].title

    const heroTitle = isMonthDynamic
      ? `${hero[0]?.subtitle} ${getCurrentMonth()}`
      : heroText

    return heroTitle
  }

  return title
}

const clearCanonical = (path) => {
  const clearTraillingSlash = (path) =>
          path.endsWith('/') ? path.slice(0, -1) : path;
  return clearTraillingSlash(path).replaceAll(`/undefined`, '')
}

const useSeo = ({ pageContext, location }) => {
  if (!pageContext?.content) return
  const title = pageContext?.content?.title

  const titlePage = {
    landing: `Cartões de Crédito - Consumidor Positivo`,
    marketplace_listing_card: `Listagem de Cartões - Consumidor Positivo`,
    marketplace_product_card: `${title}: Saiba tudo sobre | Consumidor Positivo`,
  }

  const isPdp = pageContext?.content?.component === "marketplace_product_card"

  const SEOTitle = pageContext?.content?.seo_title
    ? pageContext?.content?.seo_title
    : titlePage[pageContext?.content?.component] || "Consumidor Positivo"
  const SEORobots = isDev
    ? "noindex, nofollow"
    : pageContext?.content?.seo_robots || "index, follow"
  const descriptionDefault =
    `Conheça o ${title}! Entenda sobre anuidade, taxas, renda mínima, benefícios e muito mais. Peça já!`
  const SEODescription = pageContext?.content?.seo_desc
    ? pageContext?.content?.seo_desc
    : descriptionDefault
  const SEOKeywords = "cartões, negócios, cartão de crédito"
  const imageDefault =
    "https://assets.iq.com.br/f/114280/1200x630/98133642cc/cards-social-shared.jpeg"
  const SEOImage = isPdp ? pageContext?.content?.image?.filename : imageDefault
  const SEORouteUrl = clearCanonical( STATIC_URL + location?.pathname)

  return {
    SEODescription,
    SEOImage,
    SEOKeywords,
    SEORobots,
    SEORouteUrl,
    SEOTitle,
  }
}

export default useSeo
